const SCROLL_CORRECTION_WINDOW_MS = 1800;
const SCROLL_CORRECTION_INTERVAL_MS = 120;

/** Scrolls to a section by id. Keeps re-checking/re-correcting for a short
 * window after the initial scroll, because sections below the target (e.g.
 * Gallery's async-loaded photos) can still be loading and expand the page
 * height mid-animation, which would otherwise make the scroll land short. */
export const scrollToSectionId = (id) => {
  const deadline = Date.now() + SCROLL_CORRECTION_WINDOW_MS;
  const tick = () => {
    const el = document.getElementById(id);
    if (el) {
      const stillMisaligned = Math.abs(el.getBoundingClientRect().top) > 4;
      if (stillMisaligned) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (Date.now() < deadline) setTimeout(tick, SCROLL_CORRECTION_INTERVAL_MS);
  };
  tick();
};
